/* global jstz */
import dom from '../helpers/dom';
import styles from '../helpers/styles';

const newsletterForm = () => {
  const selectors = {
    form: 'js-newsletter-subscription-form',
    wrapper: 'js-newsletter-form-wrapper',
    input: 'js-newsletter-email-input',
    submit: 'js-newsletter-submit-btn',
    alert: 'js-newsletter-alert',
    errorContainer: 'js-email-error-message',
    errorText: 'js-email-error-message-text',
  };

  const isValidEmail = (email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

  const getRandomPassword = () => Math.random().toString(36).substring(2);

  const getCurrentLocale = () => {
    const path = window.location.pathname;
    const locale = path.split('/')[1] || 'en';
    if (locale === 'pt-br') return 'pt_BR';
    if (locale === 'zh-hans') return 'zh-Hans';
    return locale;
  };

  const clearFieldError = (elements) => {
    const { input, container, text } = elements;
    input.classList.remove('rck-form-item-field--status-error');
    input.setAttribute('aria-invalid', 'false');
    styles.hideElement(container);
    text.textContent = '';
  };

  const showFieldError = (type, elements) => {
    const { input, container, text } = elements;
    const fallback = 'Error';

    const message = window.newsletterTranslations?.[type] || fallback;

    input.classList.add('rck-form-item-field--status-error');
    input.setAttribute('aria-invalid', 'true');
    styles.showElement(container);
    text.textContent = message;
  };
  const resetForm = (elements, clearValue = true) => {
    const { input, submit } = elements;
    if (submit) {
      submit.removeAttribute('disabled');
      submit.classList.remove('rck-btn--loading');
    }
    input.removeAttribute('disabled');
    if (clearValue) input.value = '';
  };

  const announce = (type) => {
    const message = window.newsletterTranslations?.[type];
    const region = dom.getFirstByClassName('js-newsletter-live-region');
    const text = dom.getFirstByClassName('js-newsletter-live-text');

    if (!region || !text || !message) return;

    region.classList.remove('rck-alert-box--success', 'rck-alert-box--error');

    if (type === 'success') {
      region.classList.add('rck-alert-box--success');
    } else {
      region.classList.add('rck-alert-box--error');
    }

    text.textContent = message;
    styles.showElement(region);
  };

  const setSuccessState = (wrapper, elements) => {
    resetForm(elements);
    wrapper.classList.add('qusd-newsletter-form-wrapper--success');
    clearFieldError(elements);
    announce('success');
  };

  const setErrorState = (wrapper, elements, isDuplicate = false) => {
    resetForm(elements, false);
    const type = isDuplicate ? 'duplicate' : 'generic';
    showFieldError(type, elements);
    announce(type);
    wrapper.classList.add(`qusd-newsletter-form-wrapper--${isDuplicate ? 'email-already-in-use-error' : 'generic-error'}`);
  };

  const setLoadingState = (elements) => {
    const { input, submit } = elements;
    submit.classList.add('rck-btn--loading');
    submit.setAttribute('disabled', 'true');
    input.setAttribute('disabled', 'true');
  };

  const createNewsletterSubscription = (email) => fetch('/wp-json/qustodio-divi-extension/v1/newsletter-subscription', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      password: getRandomPassword(),
      timezone: jstz.determine().name(),
      locale: getCurrentLocale(),
    }),
  });

  const init = () => {
    const wrapper = dom.getFirstByClassName(selectors.wrapper);
    const form = dom.getFirstByClassName(selectors.form, wrapper);
    const input = dom.getFirstByClassName(selectors.input, wrapper);
    const submit = dom.getFirstByClassName(selectors.submit, wrapper);
    const container = dom.getFirstByClassName(selectors.errorContainer, wrapper);
    const text = dom.getFirstByClassName(selectors.errorText, wrapper);

    if (!form || !input || !submit || !wrapper || !container || !text) return;

    const elements = {
      input,
      submit,
      container,
      text,
    };

    input.addEventListener('focus', () => {
      if (!input.classList.contains('rck-form-item-field--status-error')) {
        input.classList.add('rck-form-item-field--has-focus');
      }
    });

    input.addEventListener('input', () => {
      const value = input.value.trim();
      if (value && isValidEmail(value)) {
        clearFieldError(elements);
      }
    });

    input.addEventListener('blur', () => {
      const value = input.value.trim();
      if (!value) {
        showFieldError('required', elements);
      } else if (!isValidEmail(value)) {
        showFieldError('invalid', elements);
      }
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = input.value.trim();

      if (!isValidEmail(email)) {
        showFieldError('invalid', elements);
        return;
      }

      setLoadingState(elements);

      try {
        const response = await createNewsletterSubscription(email);
        if (!response.ok) {
          setErrorState(wrapper, elements);
          return;
        }

        const { result, response: content } = await response.json();
        if (result === 'error') {
          setErrorState(
            wrapper,
            elements,
            content.error === 'Account email already in use',
          );
          return;
        }

        setSuccessState(wrapper, elements);
      } catch {
        setErrorState(wrapper, elements);
      }
    });
  };

  return { init };
};

export default newsletterForm();
